/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 10:15:17
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-13 15:15:22
 * @FilePath: /dsicm-admin-web/src/views/treatment/common/index.js
 */
import moment from 'moment'

export default {
    data(){
        return{

        }
    },
    computed: {
        contractFile() {
            return this.$store.state.chatUserList
        },
        userDataListCopy(){
            if(this.userDataList.length){
                this.userDataList = this.userDataList.map(item => {
                    this.$store.state.chatUserList.map(sub=>{
                        if(item.imId == sub.conversationID) {
                            //TODO 排序定义
                            item.sortTime = sub.lastMessage.lastTime;
                            item.unreadCount = sub.unreadCount;
                            item.lastTime = sub.lastMessage.lastTime ? moment(parseInt(sub.lastMessage.lastTime *1000)).format('MM-DD HH:mm') : '';
                        }
                    })
                    if (!item.lastTime) {
                        item.lastTime = item.msgTime ? moment(parseInt(item.msgTime *1000)).format('MM-DD HH:mm') : '';
                    }
                    return item
                });
                // this.userDataList.sort((a,b)=>{
                //     return  b.sortTime - a.sortTime 
                // })
                return this.userDataList
            }
        }
    },
    watch: {
        contractFile: {
            immediate: true,
            handler(newval,oldVal) {
                if(this.userDataList.length){
                    this.userDataList = this.userDataList.map(item => {
                        this.$store.state.chatUserList.map(sub=>{
                            if(item.imId == sub.conversationID) {
                                item.unreadCount = sub.unreadCount;
                                item.lastTime = sub.lastMessage.lastTime ? moment(parseInt(sub.lastMessage.lastTime *1000)).format('YYYY-MM-DD hh:mm:ss') : '';
                            }
                        })
                        if (!item.lastTime) {
                            item.lastTime = item.msgTime ? moment(parseInt(item.msgTime *1000)).format('MM-DD HH:mm') : '';
                        }
                        return item
                    });
                }
            }
        }
    },
}